export const Prototype_Projects = 'Prototype_Projects';
export const Portfolio_Blog_Posts = 'Portfolio_Blog_Posts';